import React, { useState } from "react";
import Select from "./Select";

const GroupLink = () => {
    const [service, setService] = useState({ value: null });
    const services = [
        { "serviceName": "アルバイトEX", "url": "https://arubaito-ex.jp/" },
        { "serviceName": "転職EX", "url": "https://tenshoku-ex.jp/" },
        { "serviceName": "看護師求人EX", "url": "https://kangokyujin-ex.jp/" },
        { "serviceName": "派遣EX", "url": "https://haken-ex.jp/" },
        { "serviceName": "knoock", "url": "https://knoock.jp/" },
        { "serviceName": "賃貸スモッカ", "url": "https://smocca.jp/" },
        { "serviceName": "引越し見積もりEX", "url": "https://hikkoshi-ex.jp/" },
        { "serviceName": "エリアビジネスマーケティング", "url": "https://areabusinessmarketing.com/" },
        { "serviceName": "ミノリノ", "url": "https://menoreno.jp/" },
        { "serviceName": "中古車EX", "url": "https://kuruma-ex.jp/usedcar" },
        { "serviceName": "セルトレ", "url": "https://sell.tc-v.com/" },
        { "serviceName": "リショップナビ エクステリア", "url": "https://www.gaikoumitsumori.biz/" },
        { "serviceName": "リショップナビ", "url": "https://rehome-navi.com/" },
        { "serviceName": "リショップナビ外壁塗装", "url": "https://pronuri.com/" },
        { "serviceName": "エネピ", "url": "https://enepi.jp/" },
        { "serviceName": "グリエネ", "url": "https://griene.jp/" },
        { "serviceName": "フランチャイズ比較ネット", "url": "https://www.fc-hikaku.net/" },
        { "serviceName": "留学くらべーる", "url": "https://ryugaku.kuraveil.jp/" },
        { "serviceName": "結婚相談所比較ネット", "url": "https://kekkon.kuraveil.jp/" },
        { "serviceName": "家庭教師比較くらべーる", "url": "https://kateikyoushi.kuraveil.jp/" },
        { "serviceName": "学習塾比較くらべーる", "url": "https://kateikyoushi.kuraveil.jp/juku" },
        { "serviceName": "fabiz", "url": "https://fabiz.jp/" },
        { "serviceName": "Clover", "url": "https://clover.minden.jp/" },
        { "serviceName": "みん電占い", "url": "https://sp.minden.jp//" },
        { "serviceName": "CareerPlus", "url": "https://careerplus-info.com/" },
        { "serviceName": "MatchinGood", "url": "https://www.matchingood.co.jp/" },
        { "serviceName": "マイリク マイページ", "url": "https://pages.matchingood.co.jp/myrec.html" },
        { "serviceName": "マイリク MA/定着支援", "url": "https://pages.matchingood.co.jp/myrecruiter.html" },
        { "serviceName": "ビズコミ", "url": "https://bizcomm.net/" },
        { "serviceName": "TRAVELIST", "url": "https://travelist.jp/" },
        { "serviceName": "ミラクス介護", "url": "https://kaigo.miraxs.co.jp/" },
        { "serviceName": "miraxsシッター", "url": "https://sitter.miraxs.co.jp/" },
        { "serviceName": "ミラクス保育", "url": "https://hoiku.miraxs.co.jp/" },
        { "serviceName": "ミラクス看護", "url": "https://kango.miraxs.co.jp/" },
        { "serviceName": "建設JOBs", "url": "https://kensetsu-jobs.struct-inc.co.jp/" },
        { "serviceName": "セカイプロパティ", "url": "https://ja.sekaiproperty.com/" },
        { "serviceName": "タイズ", "url": "https://www.ee-ties.com/" },
        { "serviceName": "ドラピタ", "url": "https://dorapita.com/" },
        { "serviceName": "不動産業界の転職ならリアルエステートWORK", "url": "https://realestateworks.jp/?code=zigexn" },
        { "serviceName": "最適なサービスが見つかる場所 ミナオシ", "url": "https://3naoshi.com/" },
        { "serviceName": "不動産売却一括査定ならイエイ", "url": "https://sell.yeay.jp/" },
    ];
    const [serviceNames] = useState(services.map((item) => item.serviceName));

    const handleChange = (value) => {
        if (!value) {
            setService({ value: null });
        } else {
            setService(value);
            var service = services.find((item) => item.serviceName === value.label);
            window.open(service.url, '_blank');
        }
    };

    return (
        <div className="w-full bg-zircon">
            <div className="container flex justify-center">
                <div className="w-full md:w-85.5 max-w-full flex flex-col my-7.25">
                    <label htmlFor="services" className="block text-midnight text-sm mb-1">
                        関連サービス
                        <Select
                            id="services"
                            handleChange={handleChange}
                            options={serviceNames}
                            placeholder="サービス一覧"
                            value={service.value}
                        />
                    </label>
                </div>
            </div>
        </div>

    );
};

export default GroupLink;
